import script from "./EbgImageObject.vue?vue&type=script&setup=true&lang=ts"
export * from "./EbgImageObject.vue?vue&type=script&setup=true&lang=ts"

import "./EbgImageObject.vue?vue&type=style&index=0&id=887b778c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-887b778c"]])

export default __exports__